var map = {
	"./Cola 0 330.jpg": 1900,
	"./Cola 1L.jpg": 75,
	"./Cola 330.jpg": 3266,
	"./Cola zero 1L.jpg": 5872,
	"./Fanta 1L.jpg": 3775,
	"./Fanta 330.jpg": 2800,
	"./Filter Coffee.jpg": 2140,
	"./Fuse Tea 330.jpg": 3854,
	"./Green Tea.jpg": 1943,
	"./Sprite 1L.jpg": 1747,
	"./Sprite 330.jpg": 2064,
	"./Tashkent Tea.jpg": 2696,
	"./Water.jpg": 4245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4239;